<!--
 * @Author: your name
 * @Date: 2021-09-27 17:48:35
 * @LastEditTime: 2022-01-25 14:28:39
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\orderMoney\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <!-- <el-col :span="span">
      <el-form-item :label="$t('goodsPage.spuCode')" prop="spu">
        <BjInput
          v-model="form.spu"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('settingAssignGoods.addAndEdit.codePlaceholder')"
          disabled
        >
          <el-button slot="append" @click="openProductDialog">{{ $t('settingAssignGoods.addAndEdit.selectCommodity') }}</el-button>
        </BjInput>
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingAssignGoods.table.name')" prop="spuName">
        <BjInput
          v-model="form.spuName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('settingAssignGoods.addAndEdit.codePlaceholder')"
          disabled
        />
      </el-form-item>
    </el-col> -->
    <el-col :span="span">
      <el-form-item :label="$t('settingAssignGoods.table.price')" prop="logisticCompanyId">
        <BjSelectLogisticCompany
          :value="form.logisticCompanyId"
          :default-options="{
            label: form.logisticCompanyName,
            value: form.logisticCompanyId,
          }"
          @change="onLogistic"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingAssignGoods.addAndEdit.business')" prop="logisticBusinessId">
        <BjSelectLogisticBusiness
          :value="form.logisticBusinessId"
          :disabled="!form.logisticCompanyId"
          :default-params="defaultParams"
          :default-options="{
            label: form.logisticBusinessName,
            value: form.logisticBusinessId,
          }"
          :placeholder="form.logisticCompanyId ? $t('chooseText') : $t('settingAssignGoods.addAndEdit.logisticsText')"
          @change="onBusiness"
        />
      </el-form-item>
    </el-col>
    <!-- 商品 -->
    <BjDialogList
      ref="dialogList"
      :config="$BjDialogListConfig.spuDefault()"
      row-keys="spuCode"
      @confirm="onConfirmDialogList"
    />
  </BjDrawerForm>
</template>
<script>
import { settingApi } from '@/api';
const getDefaultForm = () => {
  return {
    spu: null,
    spuName: null,
    logisticCompanyNo: null,
    logisticCompanyId: null,
    logisticCompanyName: null,
    logisticBusinessId: null,
    logisticBusinessNo: null,
    logisticBusinessName: null,
    enabledFlag: true,
  };
};

export default {
  data() {
    return {
      span: 18,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        spu: [{ required: true, message: this.$t('settingAssignGoods.addAndEdit.codePlaceholder'), trigger: 'change' }],
        spuName: [{ required: true, message: this.$t('settingAssignGoods.addAndEdit.codePlaceholder'), trigger: 'change' }],
        logisticCompanyId: [{ required: true, message: this.$t('settingAssignGoods.addAndEdit.logisticsRules'), trigger: 'change' }],
        logisticBusinessId: [{ required: true, message: this.$t('settingAssignGoods.addAndEdit.businessRules'), trigger: 'change' }],
      },
    };
  },
  computed: {
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticCompanyId, enableFlag: true };
    },
  },
  watch: {
    'form.spu'(v, o) {
    },
  },
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('settingAssignGoods.addAndEdit.editCommodity') : this.$t('settingAssignGoods.addAndEdit.addCommodity'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    // 获取商品
    onConfirmDialogList(data) {
      const { spuCode, name } = data[0];

      this.form.spu = spuCode;
      this.form.spuName = name;
    },
    onLogistic(val, data = {}) {
      this.form.logisticCompanyId = data.id;
      this.form.logisticCompanyNo = data.code;
      this.form.logisticCompanyName = data.name;

      this.form.logisticBusinessId = null;
      this.form.logisticBusinessNo = null;
      this.form.logisticBusinessName = null;
    },
    onBusiness(val, data = {}) {
      this.form.logisticBusinessId = data.id;
      this.form.logisticBusinessNo = data.code;
      this.form.logisticBusinessName = data.name;
    },
    openProductDialog() {
      let selectedRows = [];
      if (this.form.spu || this.form.spuCode) {
        selectedRows = [
          {
            ...this.form,
            spuCode: this.form.spu || this.form.spuCode,
          },
        ];
      }
      this.$refs.dialogList.show(selectedRows);
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      if (this.isEdit) {
        settingApi.updateStrategyGoods(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      } else {
        settingApi.addStrategyGoods(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
